// React
import AlgoliaSearch from './AlgoliaSearch'

export default function ComponentSelect2({ ...props }) {
    return (
        <>
            <AlgoliaSearch algolia_index="engine_components" {...props} />
        </>
    )
}
